import { ToneDto, ToneDtoImpl } from '../tonedto';

export interface GetBannerToneDto extends ToneDto
{
    getTuneType():string;
    getBannerOrder():string;
}

export class GetBannerToneDtoImpl extends ToneDtoImpl implements GetBannerToneDto
{
    private tuneType: string;
    private bannerOrder: string;

    setTuneType(tuneType: string)
    {
        this.tuneType = tuneType;
    }
    getTuneType(): string
    {
        return this.tuneType;
    }

    setBannerOrder(bannerOrder: string)
    {
        this.bannerOrder = bannerOrder;
    }
    getBannerOrder(): string
    {
        return this.bannerOrder;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getbannerdetails/getbannertonedto.ts